import { isValidUrl } from '@/util'
import { MATCHERS } from '@/util/linkMatcher'
import { AutoFocusPlugin } from '@lexical/react/LexicalAutoFocusPlugin'
import { AutoLinkPlugin } from '@lexical/react/LexicalAutoLinkPlugin'
import { LexicalComposer } from '@lexical/react/LexicalComposer'
import { ContentEditable } from '@lexical/react/LexicalContentEditable'
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary'
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin'
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin'
import { ListPlugin } from '@lexical/react/LexicalListPlugin'
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin'
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin'
import { TabIndentationPlugin } from '@lexical/react/LexicalTabIndentationPlugin'
import type { EditorState, LexicalEditor } from 'lexical'
import ButtonToolbar from 'react-bootstrap/ButtonToolbar'
import { LEXICAL_DEFAULT_CONFIG } from './conf'
import EmojisPlugin from './plugin/logic/EmojisPlugin'
import InitEditorStatePlugin from './plugin/logic/InitEditorStatePlugin'
import AlignmentUIPlugin from './plugin/ui/AlignmentUIPlugin'
import InsertionUIPlugin from './plugin/ui/InsertionUIPlugin'
// import SaveButtonUIPlugin from './plugin/ui/SaveButtonUIPlugin'
import TextFormatUIPlugin from './plugin/ui/TextFormatUIPlugin'
import TextTypographyUIPlugin from './plugin/ui/TextTypographyUIPlugin'
import UndoRedoUIPlugin from './plugin/ui/UndoRedoUIPlugin'
import ImageDeletePlugin from './plugin/logic/ImageDeletePlugin'
import { editorContainer, editorInner, editorInput, editorPlaceholder } from './style.css'

const placeholder = 'テキストを入力してください'

export type EditorProps = {
  onChange: (editorState: EditorState, editor: LexicalEditor, tags: Set<string>) => void
  savedEditorState?: any // eslint-disable-line @typescript-eslint/no-explicit-any
}

export default function Editor({ onChange, savedEditorState }: EditorProps) {
  return (
    <LexicalComposer
      initialConfig={{
        ...LEXICAL_DEFAULT_CONFIG,
        namespace: 'kosen-editor',
        /*
        editorState: (editor) => {
          if (editor && savedEditorState) {
            editor.setEditorState(editor.parseEditorState(savedEditorState))
          }
        },
        */
      }}
    >
      <InitEditorStatePlugin savedEditorState={savedEditorState} />
      <OnChangePlugin onChange={onChange} />
      <EmojisPlugin />
      <HistoryPlugin />
      <AutoFocusPlugin />
      <ListPlugin />
      <LinkPlugin validateUrl={isValidUrl} />
      <TabIndentationPlugin />
      <AutoLinkPlugin matchers={MATCHERS} />
      <ImageDeletePlugin />
      <div className={editorContainer}>
        <ButtonToolbar className="mb-3" aria-label="rich-text-control-panel">
          <UndoRedoUIPlugin />
          <TextTypographyUIPlugin />
          <TextFormatUIPlugin />
          <AlignmentUIPlugin />
          <InsertionUIPlugin />
          {/*<SaveButtonUIPlugin />*/}
        </ButtonToolbar>
        <div className={editorInner}>
          <RichTextPlugin
            contentEditable={
              <ContentEditable
                className={editorInput}
                aria-placeholder={placeholder}
                placeholder={<div className={editorPlaceholder}>{placeholder}</div>}
              />
            }
            ErrorBoundary={LexicalErrorBoundary}
          />
        </div>
      </div>
    </LexicalComposer>
  )
}
